<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="content-wrapper"
      v-if="$firebase.isAuthenticated && getMode != 'production1' && getClientId == 'tryt'">
      <h2>지원해봐요</h2>
      <div class="text-center" style="width:100%">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            <img src="/kr/resume/static/renew_img/bnr/tryt_bnr_kango.png" style="width:80%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 100%;">yagish에서는 이력서/경력기술서를 작성 해주신 분께</p>
          <p style="font-size: 100%;">취업활동에 도움을 드리고 있습니다.</p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            <img src="/kr/resume/static/renew_img/tryt_yagish_logo.png" style="width:70%">
          </p>
        </div>
        <p>
          Yagish의<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">이용약관</router-link>,<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">개인정보보호방침</router-link><br />
          ㈜트라이트캐리어의<a href="https://tryt-career.co.jp/sitepolicy/" target="_blank">이용약관</a>,<a
            href="https://tryt-career.co.jp/handling/" target="_blank">개인정보취급</a><br />
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 120%;">
          <img src="/kr/resume/static/renew_img/check_icon.png" style="width:40px">이용약관에 동의
        </p>
      </div>
      <div class="text-center">
        <br />
        <el-button id="resend_secure" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
          @click="sendTrytConsult()">지원</el-button>
        <br />
      </div>
      <div class="card detail">
        <br />
        <div class="card-thumbnail">
          <ul class="doc-sample-images">
            <li>
              <img src="/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg">
            </li>
            <li>
              <img src="/kr/resume/static/img/formats/sample/rirekisho_job_change_02.jpg">
            </li>
          </ul>
        </div>
        <br />
      </div>
      <div class="text-center">
        <el-button id="resend_secure" type="success" @click="confirmBackup()"><i class="el-icon-view"></i>
          미리보기</el-button>
        <br />
        <br />
        <a href="/kr/resume/format/rirekisho_job_change_old">＞ 수정</a>
      </div>
      <div class="page-static-inner">
        <rirekisho-preview ref="makeHtmlRirekishoViewer" v-show="false" :id-prefix="'backup'"
          :format-data="formattedBackupData.format_rirekisho"
          :basic-data="formattedBackupData.basicData"></rirekisho-preview>
        <shokurekisho-preview ref="makeHtmlShokumuViewer" v-show="false" :id-prefix="'shokumukeirekisho_backup'"
          :format-data="formattedBackupData.format_shokumukeirekisho"
          :basic-data="formattedBackupData.basicData"></shokurekisho-preview>
      </div>
    </section>
    <section class="content-wrapper" v-else>
      <h2>로그인해서 지원 해주세요.</h2>
      <div class="text-center" style="width:100%">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            <img src="/kr/resume/static/renew_img/bnr/tryt_bnr_kango.png" style="width:80%">
          </p>
        </div>

        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 100%;">yagish에서는 이력서/경력기술서를 작성 해주신 분께</p>
          <p style="font-size: 100%;">취업활동에 도움을 드리고 있습니다.</p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            <img src="/kr/resume/static/renew_img/tryt_yagish_logo.png" style="width:70%">
          </p>
        </div>
        <p>
          Yagish의<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">이용약관</router-link>,<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">개인정보보호방침</router-link><br />
          (㈜트라이트캐리어의<a href="https://tryt-career.co.jp/sitepolicy/" target="_blank">이용약관</a>,<a
            href="https://tryt-career.co.jp/handling/" target="_blank">개인정보취급</a><br />
        </p>
      </div>
      <div class="text-center">
        <login-forms />
      </div>
    </section>

    <modal name="confirm-backup-dialog" :adaptive="true" :scrollable="true" height="auto"
      @opened="setPreviewScale(); previewLoading = false">
      <div class="v--modal-close-top">
        <el-button @click="closeDialog" icon="el-icon-close" type="text"></el-button>
      </div>
      <div v-if="backupDataToConfirm" class="backup-preview-dialog">
        <el-tabs v-model="activePreviewTab" class="backup-tabs" :stretch="true"
          @tab-click="setPreviewScale(); previewLoading = false">
          <el-tab-pane label="이력서" name="format_rirekisho" :lazy="true" :style="backupDataViewerCssRirekisho">
            <rirekisho-preview ref="backupDataViewer" :id-prefix="'backup'"
              :format-data="formattedBackupData.format_rirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></rirekisho-preview>
          </el-tab-pane>
          <el-tab-pane label="경력기술서" name="format_shokumukeirekisho" :lazy="true"
            :style="backupDataViewerCssShokurekisho">
            <shokurekisho-preview ref="backupDataViewer" :id-prefix="'backup'"
              :format-data="formattedBackupData.format_shokumukeirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></shokurekisho-preview>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="text-right">
        <el-button @click="closeDialog">닫기</el-button>
      </div>
      <br /><br />
    </modal>
  </div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<script>
import {
  TabPane,
  Tabs
} from 'element-ui'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    clientId: {
      type: String
    }
  },
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'letter-preview': LetterPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick,
    StripeElementCard
  },
  data: function () {
    return {
      publishableKey: 'pk_test_51Lrzk0JrhRfOPjZJiVIjIPn4F0sfsjCUXzi4wlx5ocQwUP5LtUHE1zcxuQjK7619as6wc0lD5JHvlQ0XTFrD8wAX006RZLflhO',
      fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      token: null,
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code: '',
      username: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      mailPDFSending: false,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    formattedBackupData: function () {
      if (!this.backupDataToConfirm) return {}
      const content = JSON.parse(this.backupDataToConfirm.value.content)
      console.error(content)
      return {
        lastSaveDate: this.backupDataToConfirm.value.lastSaveDate,
        label: this.backupDataToConfirm.value.label,
        format_rirekisho: content.format_rirekisho || {},
        format_shokumukeirekisho: content.format_shokumukeirekisho || {},
        format_letter: content.format_letter || {},
        basicData: content.basicData || {},
        platform: this.backupDataToConfirm.value.platform
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    getClientId: function () {
      return this.clientId
    }
  },
  methods: {
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          // console.log(clientWidth, this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height = this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
      } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      }
    },
    openDialog: function () {
      this.$modal.show('confirm-backup-dialog')
      this.backupDataViewerCssRirekisho = {}
      this.backupDataViewerCssShokurekisho = {}
    },
    closeDialog: function () {
      this.$modal.hide('confirm-backup-dialog')
      this.deleteBackupPopoverVisible = false
    },
    confirmBackup: function () {
      // console.log(backup)
      // this.backupDataToConfirm = backup
      this.previewLoading = true
      this.openDialog()
    },
    loadBackupList: function (type) {
      const app = this
      app.backupListLoaded[type] = false
      app.backupList[type] = []
      app.$firebase.getBackupList('all', 1)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            app.backupDataToConfirm = {
              id: doc.id,
              value: doc.data()
            }
            app.backupList[type].push({
              id: doc.id,
              value: doc.data()
            })
          })
          app.backupListLoaded[type] = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    loadBackup: function (backup) {
      this.$firebase.loadBackup(backup.id)
      this.closeDialog()
    },
    dataChanged: function () {
      this.saved = false
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    getBackups: function (force) {
      if (this.$deviceLib.isOnline && this.$firebase.isAuthenticated) {
        if (force) {
          this.loadBackupList('auto')
          this.loadBackupList('user')
        } else {
          if (!this.backupListLoaded['user']) {
            this.loadBackupList('user')
          }
          if (!this.backupListLoaded['auto']) {
            this.loadBackupList('auto')
          }
        }
      }
    },
    checkPreviewHtml: function () {
      this.$refs.elementRef.submit();
      console.error("checkPreviewHtml")
      console.error(this.token)

      // this.mailPDF(this.$refs.makeHtmlRirekishoViewer.$el.innerHTML,
      //   this.$refs.makeHtmlShokumuViewer.$el.innerHTML)
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendTrytConsult: async function () {
      if (true) {
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '현재 오프라인입니다.인터넷 연결 후 다시 시도해 보세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('app_html', this.$refs.makeHtmlRirekishoViewer.$el.innerHTML)
      formData.append('app_keireki_html', this.$refs.makeHtmlShokumuViewer.$el.innerHTML)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', 'rirekisho_job_change_old')
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'tryt_mailmaga')
      formData.append('permission_type', 1)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendTryt, formData, { timeout: 60000 })
        .then(function (response) {
          app.isTrytSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    mailPDF: async function (cleanedPreviewHtml, cleanedKeirekiPreviewHtml) {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '현재 오프라인입니다.인터넷 연결 후 다시 시도해 보세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      this.mailPDFSending = true
      const formData = new FormData()
      formData.append('app_html', cleanedPreviewHtml)
      formData.append('app_keireki_html', cleanedKeirekiPreviewHtml)
      formData.append('pdf_option', 'A4')
      formData.append('token', accessToken)
      formData.append('format_id', 'this.formatId')
      formData.append('inputemail', 'k.kim@yagish.jp')
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('filename', 'asdf.pdf')
      formData.append('version', '2')
      this.$axios
        .post(this.$varuna.endPoints.testMultiMailPdf, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            message: '전송 하였습니다.',
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.mailPDFSending = false
        })
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {

        this.fullscreenLoading = false

      } else {
        this.fullscreenLoading = false
      }
    })
    this.loadRecentEdit()
  },
  beforeMount: function () {
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.getBackups)
    this.getBackups()
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      //console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed');
      }
    })
  },
  destroyed: function () {
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.getBackups)
  }
}
</script>
